export default __webpack_public_path__ + "static/media/Group3248.2b03b72a.svg";